import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Banner from './components/Banner';
import FillterButton from './components/FilterButton';
import MainCalendar from './components/MainCalendar';
import MainService from '../../service/main/main';
import ItemAndSample from './components/ItemAndSample';
import Footer from '../components/footer/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';
import QuantBox from './components/QuantBox';
import UserService from '../../service/User';
import TopBanner from './components/TopBanner';
import PopupBanner from '../components/PopupBanner';
import MainNews from './components/MainNews';
import Notice from './components/Notice';
import Youtube from './components/Youtube';
import { MainPageTop } from '../components/pageTop/MainPageTop';
import Announcement from './components/Announcement';
import MainServiceSection from './components/MainServiceSection';
import Algorithm from './components/Algorithm';
import NplHilight from './components/NplHilight';
import { PageContainer } from '../components/common/PageComponent.style';

const Main = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [openChatModal, setOpenChatModal] = useState(false);
  const [currentTab, setCurrentTab] = useState('간편검색');
  const [imminentList, setImminentList] = useState(); // 매각임박물건
  const [sampleList, setSampleList] = useState(); // 샘플데이터
  // const [exchangeStatus, setExChangeStatus] = useState(); // 교환소 상태
  // const [ExchangeHiLightList, setExchangeHiLightList] = useState(); // 교환소 하이라이트
  const [exchangeList, setExchangeList] = useState(); // 교환소 리스트
  const [noticeList, setNoticeList] = useState([]); // 공지사항 리스트
  const [bannerVisiable, setBannerVisiable] = useState(true);

  if (!sessionStorage.getItem('reloaded')) {
    sessionStorage.setItem('reloaded', 'true');
    window.location.reload();
  }

  const getMainData = async () => {
    setIsLoading(true);
    try {
      const result = await MainService.main();
      setNoticeList(result.data.noticeList.list);
      setImminentList(result.data.imminentList);
      setSampleList(result.data.sampleList);
    } catch (error) {
      console.error('Error fetching main data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getModalData = () => {
    if (
      sessionStorage.getItem('event_modal') ===
      `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
    ) {
      setOpenModal(false);
    } else {
      setOpenModal(true);
    }

    // if (
    //   localStorage.getItem('chat_modal') ===
    //   `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
    // ) {
    //   setOpenChatModal(false);
    // } else {
    //   setOpenChatModal(true);
    // }
  };

  useEffect(() => {
    getUserInfo();
    getModalData();
    getMainData();
    // getExchangeList();
    // getExchangeStatus();
  }, []);

  const [userdata, setuserData] = useState({ plan_grade: '' });
  const getUserInfo = async () => {
    try {
      if (localStorage.getItem('accessToken')) {
        const res = await UserService.userInfo();
        setuserData(res.data);
      } else {
        setuserData({ plan_grade: 'N' });
      }
    } catch (error) {
      setuserData({ plan_grade: 'N' });
      console.error('userInfo 함수에서 에러 발생:', error);
    }
  };

  return (
    <PageContainer $bg="#f3f4f6">
      {bannerVisiable && <TopBanner onClose={() => setBannerVisiable(false)} />}
      <ScrollToTopButton />
      <MainPageTop />
      <Announcement noticeList={noticeList} isLoading={isLoading} />
      <MainServiceSection />
      <Banner />
      <FillterButton />
      <Algorithm />
      <QuantBox />
      <MainCalendar />

      <BottomSectionArea>
        {/* NPL 플랫폼 하이라이트 */}
        <NplHilight />

        {/* 매각임박 물건 */}
        {sampleList && imminentList && (
          <ItemAndSample imminentList={imminentList} sampleList={sampleList} />
        )}

        {/* 경공매 뉴스 */}
        <MainNews />

        {/* 공지사항 */}
        <Notice noticeList={noticeList} isLoading={isLoading} />

        {/* 유튜브 */}
        <Youtube />
      </BottomSectionArea>

      {(openModal || openChatModal) &&
        userdata?.plan_grade !== 'T' &&
        userdata?.plan_grade !== '' && (
          // <EventModal setOpenModal={setOpenModal} />
          <PopupBanner
            openModal={openModal}
            openChatModal={openChatModal}
            setOpenModal={setOpenModal}
            setOpenChatModal={setOpenChatModal}
          />
        )}
      <Footer />
    </PageContainer>
  );
};

export default Main;

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background-color: rgba(112, 115, 124, 0.05);
`;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  background: #f3f4f6;
`;

const ScrollContainer = styled.div`
  padding: 16px 16px 32px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Top = styled.div`
  background: linear-gradient(90deg, #2b1b59 0%, #151120 100%);
  background-blend-mode: multiply;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const BottomSectionArea = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 16px 16px 0 0;
`;
